/*
 * action types
 */

export const TOGGLE_REMARK_SCREEN = 'TOGGLE_REMARK_SCREEN';


// WEBPACK FOOTER //
// ./src/state/actionTypes.js